<template>


    <Menu as="div"
          class="relative inline-block text-left ml-4"
          style="height: 22px">


        <div class="flex">


            <MenuButton
                class="inline-flex justify-center w-full text-md
                font-medium focus:outline-none focus:ring-2 focus:ring-offset-2
                focus:ring-offset-gray-100 focus:ring-indigo-500 items-center leading-[22px]">

                {{ selected.name }}


                <font-awesome-icon
                    class="mr-1 ml-2 justify-center font-bold w-[12px] h-[12px] mt-[4px]"
                    size="sm"
                    :icon="[`${icon_type}`, `${icon}`]" />

            </MenuButton>


        </div>


        <transition enter-active-class="transition ease-out duration-100"
                    enter-from-class="transform opacity-0 scale-95"
                    enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-from-class="transform opacity-100 scale-100"
                    leave-to-class="transform opacity-0 scale-95">


            <MenuItems class="max-w-[15em] origin-top-right absolute right-0 mt-2 rounded-md
                              shadow-lg bg-white ring-1 ring-black ring-opacity-5
                              divide-y divide-gray-100 focus:outline-none w-max">

                <template v-for="choice of dropdown_choices"
                    :key="choice.id">

                    <MenuItem
                        @click.exact="$emit('clicked_item',choice)"
                        v-slot="{ active }">

                        <div class="py-3"
                             :class="[
                                active
                                    ? 'bg-gray-100 text-gray-900'
                                    : 'text-gray-700', 'block px-4 py-2 text-sm'
                            ]">

                            {{ choice.name }}

                        </div>

                    </MenuItem>


                </template>


            </MenuItems>


        </transition>


    </Menu>


</template>


<script>
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { defineComponent } from 'vue'

export default defineComponent( {

    components: {
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
    },

    props: {

        icon: {
            type: String,
            default: 'chevron-down'
        },

        icon_type: {
            type: String,
            default: 'fas'
        },

        selected: {
            type: Object,
            default: () => {
                return {
                    id: 0,
                    name: 'All Topics'
                }
            }
        },

        choices: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        name: 'Countries and Regions',
                    },
                    {
                        id: 2,
                        name: 'Culture, Leisure and Media',
                    },
                    {
                        id: 3,
                        name: 'Legislation and Justice',
                    },
                    {
                        id: 4,
                        name: 'Environment and Climate',
                    },
                    {
                        id: 5,
                        name: 'The Nordic Region and the Surrounding World'
                    },
                    {
                        id: 6,
                        name: 'Education and Research'
                    },
                    {
                        id: 7,
                        name: 'Welfare and Gender Equality'
                    },
                    {
                        id: 8,
                        name: 'Economy, Business and Working Life'
                    },
                    {
                        id: 9,
                        name: 'Nordic Council prizes'
                    },
                    {
                        id: 10,
                        name: 'Nordic Council sessions'
                    }
                ]
            }
        },
    },

    computed: {

        dropdown_choices() {

            let
                choices = this.choices
            ;

            if ( !! this.selected ) {

                _.remove(choices,{
                    id: this.selected.id
                });

            }

            return choices;

        }

    }

})
</script>
